import { getTrafficMessages } from "../../../services/OgcService/TrafficMessageService";
import { useTrafficMessageActions, useTrafficMessageIsLoading, useTrafficMessages } from "../../../stores/MapLayers/TrafficMessagesStore"
import { Button } from "@mui/material";
import { TrafficMessageIcon } from "../../../assets/trafficMessageIcon";
import { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { margin } from "@mui/system";


export interface ITrafficMessageMapLayerProps {
}

export function TrafficMessageMapLayer(props: ITrafficMessageMapLayerProps) {
    const [className, setClassName] = useState('mapLayerContainerInactive');
    const trafficMessages = useTrafficMessages();
    const isLoading = useTrafficMessageIsLoading();
    const { setTrafficMessages, setIsLoading } = useTrafficMessageActions();

    async function handleClick() {
        if (trafficMessages == null) {
            setIsLoading(true);
            setTrafficMessages(await getTrafficMessages())
            setIsLoading(false)
        }
        else {
            setTrafficMessages(null);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if(trafficMessages !== null){
            setClassName('mapLayerContainerActive')
        }
        else{
            setClassName('mapLayerContainerInactive')
        }
    }, [trafficMessages])


    return (
        <div style={{display: 'grid', maxHeight: '90%', marginLeft: "20px"}}>
            <div className={className} onClick={handleClick}>
                {isLoading &&
                    <div className="loadingSpinner">
                        <CircularProgress style={{ textAlign: 'center', marginTop: '15%' }} />
                    </div>
                }

                <TrafficMessageIcon />

            </div>
            <p style={{ fontSize: '14px', margin: 'auto', fontWeight: 'bold' }}>Trafikkmeldinger</p>
        </div>
    )

}